import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import Layout from '@src/pages/layout'
import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
import SomethingWentWrong from '@src/quince-site-common/src/organisms/somethingWentWrong'
import MyStoreCredit from '@src/quince-site-integrated/src/templates/Account/my-store-credit'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { getServerSideBaseProps } from '@src/server-side/get-server-side-props'

export const getServerSideProps = (async ctx => {
  const serverSideBaseProps = await getServerSideBaseProps(ctx, PAGE_PATH.MY_STORE_CREDITS)
  return serverSideBaseProps
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function PageAccountsMyStoreCredit(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return <Layout {...props}>{props.pageData ? <MyStoreCredit data={props.pageData} /> : <SomethingWentWrong />}</Layout>
}
